// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_hl-1";
export var quotedThread = "_hl-0";